export default "__VITE_ASSET__DZP87uT$__"